export default "/images/f65e8497845955e7da7081dcbb6135ec.avif";